export const PRIVACY = `

PRIVACY POLICY

NESSEFY

Updated at: June 30th, 2026

NESSEFY ("we," "our," or "us") is committed to protecting your privacy.

This Privacy Policy explains how your personal information is collected, used, and disclosed by NESSEFY.

This Privacy Policy applies to our website/app and its associated subdomains (collectively, our "Service"), alongside our application, NESSEFY.

By accessing or using our Service, you signify that you have read, understood, and agree to our collection, storage, use, and disclosure of your personal information as described in this Privacy Policy and our Terms of Service.

DEFINITIONS AND KEY TERMS

Cookie:

Small amount of data generated by a website and saved by your web browser.

It is used to identify your browser, provide analytics, and remember information such as language preference or login information.

Company:

When this policy mentions "Company", "we", "us", or "our", it refers to:

NESSEFY LLP

(E9 TAGORE PARK, KOLKATA – 700039)

Country:

India

Device:

Any internet-connected device such as a phone, tablet, computer, or any other device used to visit NESSEFY and use the services.

IP Address:

Every device connected to the Internet receives a number known as an Internet Protocol (IP) address.

These numbers are usually assigned geographically and may indicate approximate location.

Personnel:

Individuals employed by NESSEFY or contracted to perform services.

Personal Data:

Information that directly or indirectly identifies a natural person.

Service:

The networking and professional platform provided by NESSEFY.

Third-party Service:

Advertisers, sponsors, promotional partners, and external providers.

You:

A person or entity registered with NESSEFY.

WHAT INFORMATION DO WE COLLECT?

We collect information when you:

• Register

• Visit our platform

• Subscribe

• Fill forms

• Interact with services

Information collected:

• Name / Username

• Phone Number

• Email Address

• Age

• Password

WHEN DOES NESSEFY USE INFORMATION FROM THIRD PARTIES?

• End User Data from Social Media

Users may voluntarily share information from external social media platforms.

• Fraud Detection & Public Data

Information may be received from automated fraud detection services and public professional networks.

DO WE SHARE THE INFORMATION WE COLLECT?

• Partners & Affiliates

Information may be shared with affiliated businesses and trusted partners.

• Service Providers

Hosting, analytics, email delivery, support, and infrastructure providers.

• Log Files & IP Addresses

Used for analytics and platform improvement.

• Legal Disclosures

Information may be disclosed where required under applicable law.

HOW DO WE USE THE INFORMATION WE COLLECT?

• Personalize your networking experience

• Improve platform features

• Improve customer support

• Run promotions and surveys

• Send platform updates and announcements

HOW DO WE USE YOUR EMAIL ADDRESS?

By submitting your email address, you agree to receive platform communication.

You may unsubscribe using available opt-out options.

We do not send unsolicited spam.

Email addresses may also be used for relevant announcements and communication targeting.

HOW LONG DO WE KEEP YOUR INFORMATION?

We retain information only for as long as necessary to provide services and comply with legal obligations.

Afterward, information may be removed or anonymized.

HOW DO WE PROTECT YOUR INFORMATION?

We implement security measures to protect your personal information.

This includes Secure Socket Layer (SSL) technology.

No platform can guarantee absolute security.

CAN I UPDATE OR CORRECT MY INFORMATION?

• Update profile information

• Request correction

• Request deletion

Verification steps may be required.

Backups may temporarily retain residual information.

CORPORATE STRUCTURE & BUSINESS TRANSFERS

• User data may transfer during mergers, acquisitions, asset sales, or restructuring.

• Affiliates may process information under the same privacy obligations.

GOVERNING LAW

This Privacy Policy is governed by the laws of India.

Any dispute shall fall under Kolkata jurisdiction.

KIDS' PRIVACY

NESSEFY does not knowingly collect information from children under 13.

If discovered, information will be removed.

CHILD SAFETY STANDARDS & CHILD SAFETY LAWS

Nessefy is committed to keeping our platform safe and strictly prohibits child sexual abuse and exploitation (CSAE) and child sexual abuse material (CSAM).

Users are not allowed to upload, share, request, promote, discuss, or engage with any content or activity involving child exploitation, grooming, sextortion, sexual abuse of minors, or any harmful behavior involving children.

CSAM includes sexual abuse material involving minors, including photos, videos, edited media, AI-generated content, or computer-generated imagery involving minors in sexually explicit or exploitative situations.

Users can report child safety concerns inside the Nessefy app through report options on profiles, posts, messages, or by contacting us at:

support@nessefy.com

When Nessefy receives a CSAE or CSAM report, we review the issue, remove violating content, suspend or permanently ban violating accounts, and report serious cases to the appropriate authorities where required by law.

Nessefy complies with applicable child safety laws and is committed to preventing misuse of the platform for child exploitation.

Child Safety Point of Contact:

support@nessefy.com

App:

Nessefy

TRACKING TECHNOLOGIES & COOKIES

• Cookies

Used for login and preferences.

• Local Storage / Sessions

Used to improve speed and user experience.

• Google Maps API

Used for location-based platform features.

CHANGES TO OUR PRIVACY POLICY

This Privacy Policy may be updated periodically.

Continued use of the platform indicates acceptance of revisions.

CONTACT US

For questions regarding this Privacy Policy:

[support@nessefy.com](mailto:support@nessefy.com)

`;


export const TERMS = `

TERMS & CONDITIONS

NESSEFY

Updated at: June 17th, 2026

GENERAL TERMS

By accessing and using NESSEFY, you confirm that you agree to and are bound by these Terms & Conditions.

These terms apply to:

• Website
• Mobile Application
• Email communications
• Platform services

Under no circumstances shall NESSEFY be liable for direct, indirect, incidental, special, or consequential damages including:

• Loss of Data
• Loss of Profit
• Service Interruption

arising from use or inability to use the platform.

NESSEFY reserves the right to revise these terms at any time.

LICENSE

NESSEFY grants you a:

• Revocable License
• Non-exclusive License
• Non-transferable License
• Limited right to use the platform

strictly under this agreement.

These Terms & Conditions represent a legal agreement between you and NESSEFY LLP.

Violation of these Terms may result in:

• Account Suspension
• Restricted Access
• Permanent Termination

DEFINITIONS AND KEY TERMS

Company

NESSEFY LLP
(E9 TAGORE PARK, KOLKATA – 700039)

Country

India

Device

Any internet-connected device used to access NESSEFY.

Service

Networking and professional platform services provided by NESSEFY.

Third-party Service

Advertisers, sponsors, promotional partners, and external providers.

You

Any registered person or entity using NESSEFY.

USER RESTRICTIONS

You agree NOT to:

• License or resell the platform

• Lease or distribute platform access

• Host or outsource platform resources

• Reverse engineer the application

• Modify source materials

• Remove copyright notices

USER CONTENT, SUBMISSIONS & SUGGESTIONS

If you submit:

• Ideas

• Concepts

• Designs

• Suggestions

• Data

• Platform improvements

You agree that:

• Submissions become non-confidential

• Submissions become non-proprietary

• NESSEFY may use them indefinitely

No compensation or ownership rights apply.

ACCOUNT MODIFICATIONS & UPDATES

Service Changes

NESSEFY may:

• Modify services

• Suspend services

• Discontinue features

with or without notice.

Platform Updates

Updates may include:

• Patches

• Bug fixes

• Improvements

• Upgrades

All updates remain governed under these Terms.

Account Access

If account access is disabled you may lose access to:

• Account Details

• Platform Data

• Uploaded Materials

THIRD-PARTY SERVICES

NESSEFY may display:

• Third-party content

• Applications

• Advertisements

• External links

NESSEFY is not responsible for:

• Accuracy

• Legality

• Reliability

• Copyright compliance

Use external services at your own discretion.

COPYRIGHT INFRINGEMENT NOTICE

If you believe content infringes copyright provide:

1. Signature of owner

2. Material identification

3. Contact information

4. Statement of good-faith belief

TERMINATION

This Agreement remains active until terminated.

NESSEFY may suspend or terminate accounts:

• At its discretion

• With or without notice

Upon termination you must stop using the Service.

DISCLAIMERS & NO WARRANTIES

NESSEFY services are provided:

"AS IS"

"AS AVAILABLE"

NESSEFY provides no guarantee regarding:

• Availability

• Reliability

• Merchantability

• Fitness for purpose

User-generated content remains the responsibility of creators.

LIMITATION OF LIABILITY

To the maximum extent permitted under Indian law:

NESSEFY shall not be liable for:

• Data Loss

• Business Interruption

• Profit Loss

• Privacy Loss

• Consequential Damages

DISPUTE RESOLUTION (INDIAN JURISDICTION)

Notice of Dispute

Send disputes to:

[support@nessefy.com](mailto:support@nessefy.com)

Both parties agree to attempt informal negotiation within:

60 Days

Governing Law

Governed by:

India

Jurisdiction:

Kolkata Courts

Time Limit

Any claim must begin within:

1 Year

MISCELLANEOUS

If any provision becomes invalid:

Remaining provisions continue in effect.

NESSEFY operates from India.

The Service is not intended where local law prohibits usage.

CONTACT US

Questions?

[support@nessefy.com](mailto:support@nessefy.com)

`;


export const COOKIE = `

COOKIE POLICY

NESSEFY

Updated at: June 17th, 2026

This Cookie Policy explains how NESSEFY ("we", "our", or "us") uses cookies and similar tracking technologies across our platform.

It explains:

• What cookies are
• Why we use them
• Your rights to manage cookies

DEFINITIONS AND KEY TERMS

Cookie

Small amount of data generated by a website and saved by your browser.

Used to:

• Identify your browser

• Provide analytics

• Remember preferences

• Maintain login information

Company

NESSEFY LLP

(E9 TAGORE PARK, KOLKATA – 700039)

Device

Any internet-connected device used to access NESSEFY.

Personal Data

Information capable of identifying a natural person directly or indirectly.

Service

Professional networking services provided by NESSEFY.

You

Registered users of NESSEFY.

INTRODUCTION

NESSEFY uses cookies to improve your platform experience.

Cookies help us:

• Understand app usage

• Remember preferences

• Secure user sessions

• Improve networking experience

WHY DO WE USE COOKIES?

We use:

• First-party cookies

• Third-party cookies

Some are required for platform operation.

Others help personalize user experiences.

TYPES OF COOKIES WE USE

Essential / Necessary Cookies

Required to:

• Maintain login sessions

• Enable security

• Operate core platform functionality

Performance & Functionality Cookies

Used to:

• Improve performance

• Enhance usability

• Support advanced platform features

Analytics & Customization Cookies

Used to:

• Understand platform usage

• Measure campaign effectiveness

• Personalize experiences

TRACKING TECHNOLOGIES

Google Maps API

Used for:

• Location-based networking

• Nearby professional matching

• Check-ins

Local Storage & Sessions

Used to:

• Improve speed

• Save preferences

• Cache data

• Improve responsiveness

HOW CAN YOU CONTROL COOKIES?

Most browsers allow:

• Manage cookies

• Delete cookies

• Disable tracking

Blocking essential cookies may:

• Affect login

• Reduce functionality

• Remove saved preferences

CHANGES TO OUR COOKIE POLICY

This Cookie Policy may be updated periodically.

Updated versions will be published here.

YOUR CONSENT

By:

• Registering

• Downloading

• Using NESSEFY

you consent to this Cookie Policy.

CONTACT US

Questions?

[support@nessefy.com](mailto:support@nessefy.com)

`;


export const DISCLAIMER = `

DISCLAIMER

NESSEFY

Updated at: June 17th, 2026

NESSEFY grants access to:

https://nessefy.com

and invites users to access networking services.

DEFINITIONS AND KEY TERMS

Cookie

Small amount of browser-stored data.

Company

NESSEFY LLP

(E9 TAGORE PARK, KOLKATA – 700039)

Service

Professional networking services provided by NESSEFY.

You

Any registered platform user.

LIMITED LIABILITY & CONTENT ACCURACY

NESSEFY attempts to maintain accurate and updated content.

However:

• User content may contain inaccuracies

• Content may become outdated

• Materials may change without notice

NESSEFY does not guarantee:

• Accuracy

• Completeness

• Reliability

External links and third-party services remain outside our control.

ERRORS AND OMISSIONS DISCLAIMER

NESSEFY is not responsible for:

• User-generated content

• Platform code errors

• Typographical mistakes

NESSEFY shall not be liable for:

• Direct damages

• Indirect damages

• Consequential damages

• Business losses

GENERAL & THIRD-PARTY CONTENT DISCLAIMER

NESSEFY acts as:

Distributor

—not—

Publisher

of third-party content.

This includes:

• Business ideas

• Founder posts

• Investor content

• User discussions

No information shared creates legal guarantees.

COPYRIGHT DISCLAIMER

Official platform materials including:

• Branding

• Layout

• Architecture

remain the intellectual property of NESSEFY.

Unauthorized copying is prohibited.

EDUCATIONAL & LEGAL INFORMATIONAL NATURE

Business insights and content are:

• Educational

• Informational

They should NOT be interpreted as:

• Legal advice

• Accounting advice

• Tax advice

Users remain responsible for actions taken.

ADVERTISING & TESTIMONIALS DISCLOSURE

The platform may display:

• Advertisements

• External professional services

• Testimonials

NESSEFY does not guarantee results shown in testimonials.

YOUR CONSENT

By:

• Using NESSEFY

• Creating an account

• Participating in the platform

you agree to this Disclaimer.

CHANGES TO OUR DISCLAIMER

Updated versions may appear periodically.

Continued usage indicates acceptance.

CONTACT US

Questions?

[support@nessefy.com](mailto:support@nessefy.com)

`;
